import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'twyne-new.ui';

import DefaultActions from '@/components/Grid/components/header/Actions';
import { useGrid } from '@Components/Grid/context';

export default function BlacklistHeaderButtons() {
  const { definitions: { entityNameModule, entityNamePlural } } = useGrid()

  const path = useMemo(() => `/${entityNameModule}/${entityNamePlural.toLowerCase()}`, [entityNamePlural, entityNameModule])

  return <DefaultActions>
    <Button color='accent' variant='outline' size='lg' asChild>
      <Link to={`${path}/import`} className="btn btn-outline-success">
        Bulk Import
      </Link>
    </Button>
  </DefaultActions>
}
